<template>
  <div v-if="!isMobile">
    <div id="report_insights" class="column">
      <div class="title_insights">
        <h1>
          {{ $t("msg.report") }}
        </h1>
      </div>

      <div class="column p10">
        <div class="column p0 content_report">
          <div class="val_m p10">
            <a
              :href="returnLink()"
              target="_blank"
              class="report_link m4_b"
              >{{ $t("msg.report_link_download_quarter") }}
            </a>
            <span class="report_link">{{ $t("msg.report_link_span") }}</span>
          </div>
          <a :href="returnLink()" target="_blank" class="icon_class_3"
            ><i v-html="iconSets.download"></i
          ></a>
        </div>
      </div>
    </div>
  </div>

  <div class="tabs_mobile" v-else>
    <div class="tab">
      <input class="tab_input" type="checkbox" id="report_insights" />
      <label class="tab-label">{{
        $t("msg.report")
      }}</label>
      <div class="tab-content">
        <div id="report_insights" >
          <div>
            <div class="column p0 content_report">
              <div class="val_m p10">
                <a
                  :href="returnLink()"
                  target="_blank"
                  class="report_link m4_b"
                  >{{ $t("msg.report_link_download_quarter") }}
                </a>
                <span class="report_link">{{
                  $t("msg.report_link_span")
                }}</span>
              </div>
              <a
                :href="returnLink()"
                target="_blank"
                class="icon_class_3"
                ><i v-html="iconSets.download"></i
              ></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  created() {
    this.checkIfMobile();
  },
  mounted() {
    this.languageSelectedOnPage = this.languageSelected;
    window.addEventListener("resize", this.checkIfMobile);
  },
  data: () => ({
    languageSelectedOnPage: "",
    isMobile: false,
  }),
  methods: {
    changeLanguage(lang) {
      this.languageSelectedOnPage = lang;
      this.$store.dispatch("setLanguageSelected", lang);
    },
    checkIfMobile() {
      let w = window,
        x = w.innerWidth;

      if (x > 900) {
        this.isMobile = false;
      } else {
        this.isMobile = true;
      }
    },


    returnLink(){
      if(this.languageSelected == 'en'){
        return '/docs/report_Q4_2022.pdf'
      }else{
        return '/docs/report_Q4_2022.pdf'
      }
    }
  },
  computed: {
    ...mapGetters(["languages", "languageSelected"]),
    storeLanguage: {
      get() {
        return this.languageSelectedOnPage;
      },
      set(value) {
        this.changeLanguage(value);
      },
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/private/insights/InsightsReports.vue